var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-3" }, [
    _vm.question.type === "text"
      ? _c("div", [
          _c(
            "label",
            {
              staticClass: "form-label my-3",
              attrs: { for: _vm.kebabCase(_vm.question.title) },
            },
            [_vm._v("\n      " + _vm._s(_vm.question.title) + "\n    ")]
          ),
          _vm._v(" "),
          (_vm.question.inputType || "text") === "checkbox"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.question.value,
                    expression: "question.value",
                  },
                ],
                staticClass: "form-control",
                class: { "is-invalid": _vm.hasError },
                attrs: {
                  id: _vm.kebabCase(_vm.question.title),
                  name: _vm.kebabCase(_vm.question.title),
                  placeholder: _vm.question.placeholder,
                  required: _vm.question.required,
                  type: "checkbox",
                },
                domProps: {
                  checked: Array.isArray(_vm.question.value)
                    ? _vm._i(_vm.question.value, null) > -1
                    : _vm.question.value,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.question.value,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.question, "value", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.question,
                            "value",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.question, "value", $$c)
                    }
                  },
                },
              })
            : (_vm.question.inputType || "text") === "radio"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.question.value,
                    expression: "question.value",
                  },
                ],
                staticClass: "form-control",
                class: { "is-invalid": _vm.hasError },
                attrs: {
                  id: _vm.kebabCase(_vm.question.title),
                  name: _vm.kebabCase(_vm.question.title),
                  placeholder: _vm.question.placeholder,
                  required: _vm.question.required,
                  type: "radio",
                },
                domProps: { checked: _vm._q(_vm.question.value, null) },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.question, "value", null)
                  },
                },
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.question.value,
                    expression: "question.value",
                  },
                ],
                staticClass: "form-control",
                class: { "is-invalid": _vm.hasError },
                attrs: {
                  id: _vm.kebabCase(_vm.question.title),
                  name: _vm.kebabCase(_vm.question.title),
                  placeholder: _vm.question.placeholder,
                  required: _vm.question.required,
                  type: _vm.question.inputType || "text",
                },
                domProps: { value: _vm.question.value },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.question, "value", $event.target.value)
                  },
                },
              }),
        ])
      : _vm.question.type === "textarea"
      ? _c("div", [
          _c(
            "label",
            {
              staticClass: "form-label my-3",
              attrs: { for: _vm.kebabCase(_vm.question.title) },
            },
            [_vm._v("\n      " + _vm._s(_vm.question.title) + "\n    ")]
          ),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.question.value,
                expression: "question.value",
              },
            ],
            staticClass: "form-control",
            class: { "is-invalid": _vm.hasError },
            attrs: {
              id: _vm.kebabCase(_vm.question.title),
              name: _vm.kebabCase(_vm.question.title),
              placeholder: _vm.question.placeholder,
            },
            domProps: { value: _vm.question.value },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.question, "value", $event.target.value)
              },
            },
          }),
        ])
      : _vm.question.type === "select"
      ? _c("div", [
          _c(
            "label",
            {
              staticClass: "form-label my-3",
              attrs: { for: _vm.kebabCase(_vm.question.title) },
            },
            [_vm._v("\n      " + _vm._s(_vm.question.title) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.question.value,
                  expression: "question.value",
                },
              ],
              staticClass: "form-select",
              class: { "is-invalid": _vm.hasError },
              attrs: {
                id: _vm.kebabCase(_vm.question.title),
                name: _vm.kebabCase(_vm.question.title),
                "aria-label": "Default select example",
              },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.question,
                    "value",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
              },
            },
            [
              _vm.question.placeholder
                ? _c("option", { attrs: { value: "" } }, [
                    _vm._v(_vm._s(_vm.question.placeholder)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.question.options, function (option) {
                return _c(
                  "option",
                  {
                    key: option.value,
                    domProps: { value: _vm.kebabCase(option.label) },
                  },
                  [_vm._v(_vm._s(option.label))]
                )
              }),
            ],
            2
          ),
        ])
      : _vm.question.type === "checkbox"
      ? _c(
          "div",
          [
            _c("label", { staticClass: "form-label my-3" }, [
              _vm._v(_vm._s(_vm.question.title)),
            ]),
            _vm._v(" "),
            _vm._l(_vm.question.options, function (option) {
              return _c(
                "div",
                { key: _vm.kebabCase(option.label), staticClass: "form-check" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selected[_vm.kebabCase(option.label)],
                        expression: "selected[kebabCase(option.label)]",
                      },
                    ],
                    key: `checkbox_${_vm.kebabCase(option.label)}`,
                    staticClass: "form-check-input",
                    class: { "is-invalid": _vm.hasError },
                    attrs: {
                      type: "checkbox",
                      id: `checkbox_${_vm.kebabCase(option.label)}`,
                    },
                    domProps: {
                      value: _vm.kebabCase(option.label),
                      checked: Array.isArray(
                        _vm.selected[_vm.kebabCase(option.label)]
                      )
                        ? _vm._i(
                            _vm.selected[_vm.kebabCase(option.label)],
                            _vm.kebabCase(option.label)
                          ) > -1
                        : _vm.selected[_vm.kebabCase(option.label)],
                    },
                    on: {
                      input: _vm.triggerInput,
                      change: function ($event) {
                        var $$a = _vm.selected[_vm.kebabCase(option.label)],
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = _vm.kebabCase(option.label),
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.selected,
                                _vm.kebabCase(option.label),
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.selected,
                                _vm.kebabCase(option.label),
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.selected,
                            _vm.kebabCase(option.label),
                            $$c
                          )
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: `checkbox_${_vm.kebabCase(option.label)}` },
                    },
                    [_vm._v(_vm._s(option.label))]
                  ),
                ]
              )
            }),
          ],
          2
        )
      : _vm.question.type === "separator"
      ? _c("div", {}, [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.snarkdown(_vm.question.title)) },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }